module.exports = __webpack_public_path__ + "img/knok_install_step9_poster.91d68847.png";